import Vue from 'vue'
import './axios'
import './auth'
import './platform/pc'
import '../theme/index.css'
import App from './App.vue'
import router from './router'
import './prototype'
import store from './store'
import './register-global-components'
import _typeof from '@/utils/typeof.js'
import '@/utils/vue-directive'
import 'utils/validate'
import './assets/iconfont/iconfont.css'
// import 'amfe-flexible'
import env from './api'
// 将类型判定，挂载到全局_上
window._ = _typeof
Vue.config.productionTip = false
Vue.axios.defaults.headers['Tenant'] = 'vcangene'
// 主要的功能业务接口的baseUrl根据接口返回的gateway设置
// Vue.axios.defaults.baseURL = res.gateway
Vue.axios.defaults.baseURL = env.api_server

// 让axios在所有请求的时候带上cookie - 微服务平台需要
Vue.axios.defaults.withCredentials = true
window.vm =
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
